import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Modal from '../../../UniformComponents/Modal'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Typography from '../../../UniformComponents/Typography'
import Button from '../../../UniformComponents/Button'
import Select from '../../form/Select'
import Input from '../../form/Input'
import Checkbox from '../../form/Checkbox'

const CrossbreakSettingsModal = ({ store }) => (
    <Modal
        show={store.crossbreakSettingsModalVisible}
        onClose={store.handleCloseCrossbreakSettingsModal}
        style={{ width: 800 }}
    >
        <Typography type="h3">{i18n.t('powerpoint.modals.crosstab.title')}</Typography>

        <br />

        <div style={{ display: 'flex', gap: 20 }}>
            <Select
                label="Select KPI"
                options={store.derivedKpiQuestions
                    .map((q) => ({ label: store.getTitle(q.question), value: q.question.id }))}
                style={{ width: '33%' }}
                onBlur={store.handleCrossbreakKpiSelection}
                defaultValue={store.crossbreakChartModalSelections.kpi}
            />

            {store.getQuestionBenchmarks(store.activeChart?.questionId, store.activeChart?.surveyId).length ? (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography type="b">{i18n.t('dashboard.benchmarksTitle')}</Typography>

                    {store.getQuestionBenchmarks(store.activeChart?.questionId, store.activeChart?.surveyId).map((y) => (
                        <Checkbox
                            label={y.label}
                            value={y.value}
                            checked={store.crossbreakChartModalSelections?.benchmarks?.includes(y.value)}
                            onBlur={() => store.handleCrossbreakToggleBenchmark(y.value)}
                        />
                    ))}
                </div>
            ) : null}
        </div>

        {store.crossbreakChartModalSelections.questions.map((q, i) => (
            <div className="pp-crossbreak-modal-question-container">
                <div className="pp-crossbreak-modal-question-title">
                    <Typography type="b">{i18n.t('powerpoint.modals.crosstab.question', { 1: i + 1 })}</Typography>

                    <Button
                        label="Delete"
                        icon="fal fa-circle-xmark"
                        style={{ color: 'red' }}
                        onClick={() => store.removeQuestionFromCrossbreak(i)}
                    />
                </div>

                <div className="pp-crossbreak-modal-question-inputs">
                    <Select
                        name="question"
                        label={i18n.t('powerpoint.labels.crossBreakSubQuestion')}
                        options={store.crossbreakCapableQuestions
                            .map((qu) => ({ value: qu.question.id, label: store.getTitle(qu.question) }))}
                        style={{ width: '100%' }}
                        defaultValue={q.question}
                        onBlur={(e) => store.handleCrossbreakSettingChange(i, e)}
                    />

                    <Select
                        name="ranking"
                        label={i18n.t('powerpoint.modals.crosstab.orderBy')}
                        options={store.chartFilterOptions}
                        style={{ width: '100%' }}
                        defaultValue={q.ranking}
                        onBlur={(e) => store.handleCrossbreakSettingChange(i, e)}
                    />

                    <Input
                        name="base"
                        type="number"
                        label={i18n.t('powerpoint.labels.removeBaseLimit')}
                        style={{ width: '100%' }}
                        defaultValue={q.base}
                        onBlur={(e) => store.handleCrossbreakSettingChange(i, e)}
                    />
                </div>
            </div>
        ))}

        <br />

        <Button
            label={i18n.t('qlist_add_question')}
            onClick={store.addQuestionToCrossbreak}
            cssClass="regular primary"
        />

        <ModalFooter>
            <div className="pp-crossbreak-modal-footer">
                <Button
                    label={i18n.t('cancel')}
                    onClick={store.handleCloseCrossbreakSettingsModal}
                    cssClass="regular tertiary"
                />

                <Button
                    label={i18n.t('save')}
                    icon="fal fa-save"
                    onClick={store.handleAddCrossbreakSlide}
                    disabled={!store.crossbreakChartModalSelections.kpi
                        || store.crossbreakChartModalSelections.questions
                            .filter((q) => !!q.question.length).length
                            !== store.crossbreakChartModalSelections.questions.length}
                    cssClass="regular primary"
                />
            </div>
        </ModalFooter>
    </Modal>
)

export default observer(CrossbreakSettingsModal)
